"use strict";
'use strict';

var card = require('./card.cjs');



exports.Body = card.CardBody;
exports.Description = card.CardDescription;
exports.Footer = card.CardFooter;
exports.Header = card.CardHeader;
exports.PropsProvider = card.CardPropsProvider;
exports.Root = card.CardRoot;
exports.Title = card.CardTitle;
